export default __webpack_public_path__ + "media/assets/fonts/081_font_iom-dd08b5dc6886d22b4353f8223f905194.ttf";